export default __webpack_public_path__ + "static/media/magnifying-glass.43026bfe.png";